import $api from "../http"
import {AxiosResponse} from "axios";

export default class UserService {
    static change_payment_information(email,name,purse_number,promocode,card_number){
        return $api.post("/change_payment_information",{email,name,purse_number,promocode,card_number})
    }
    static UseVaucher(name,data={}){
        return $api.post("/use_vouchers",{name,...data})
    }
    static UsePromocode(promocode,data={}){
        return $api.post("/use_promocode",{promocode,...data})
    }
    static change_password(data){
        return $api.post("/recover_password",data)
    }
    static changeAvatar(avatar,color){
        return $api.post("/changeAvatar",{avatar,color})
    }
    static changeLang(lang){
        return $api.get("/changeLang?lang="+lang)
    }
    static getGamesPanel(){
        return $api.get("/getGamesPanel")
    }
    static getBalance(){
        return $api.get("/getBalance")
    }

    static async change_login(login){
        return $api.post("/change_login" , {login})
    }
    static async change_skin(skin){
        return $api.post("/change_skin" , {skin})
    }
}